import React, { Component } from 'react';
import {valueCheck, percentageCheck} from '../../helpers'

export default class HorizontalBar extends Component {
  constructor(props) {
    super(props);

    this.state = { ...this.props.state };
  }
  render() {
    const { pClass, value, barColour, variations, difference, orderType, comparison } = this.props;
    const valueRating = valueCheck(value)
    const barRating = percentageCheck(value) / 5;
    return (
      <div className='w-100'>
        <p className={pClass}>
          {/* rating value */}
          {!variations && <strong className='w-10'>{valueRating}</strong>}
          <span className='w-100 bg-light-gray'>
            {/* rating bar */}
            <span className='h-100 db' style={{ width: `${barRating * 100}%`, backgroundColor: barColour, opacity: comparison ? '0.4' : '1' }}></span>
          </span>
          {variations && (
            <strong className='w-30 tc'>
              {valueRating}
              {difference && <small>{` (${orderType === 'over' ? '+' : ''}${difference.toFixed(1) === -0.55 ? '0.5' : difference.toFixed(1)})`}</small>}
            </strong>
          )}
        </p>
      </div>
    );
  }
}
